import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NotifyService } from '@app/services/notify.service';
import { StoreView } from '@common/views';
import { Employee } from '@models/employee/employee.model';
import moment from 'moment';
import { RehireService } from '@employees/services/rehire.service';
import { EmployeeRehireDetails } from '@app/modules/employees/interfaces/employee-rehire-details.interface';
import { AnalyticService } from '@app/services';
import { AnalyticEvents } from '@app/enums';

@Component({
    templateUrl: './employee-rehire.template.html',
})
export class EmployeeRehireView extends StoreView {
    isLoading = false;

    employee: Employee;

    rehireDetails: EmployeeRehireDetails = { reEnrollOnBenefits: null };

    constructor(
        private router: Router,
        private route: ActivatedRoute,
        private notify: NotifyService,
        private rehireService: RehireService,
        private analyticService: AnalyticService
    ) {
        super();
        this.employee = this.route.snapshot.data.models.get('employee');
    }

    async onSave(): Promise<void> {
        this.isLoading = true;

        try {
            await this.rehireService.rehire(
                this.employee,
                moment(this.employee.nextDayOfWorkOn).toDate(),
                this.rehireDetails
            );

            this.analyticService.trackEvent(AnalyticEvents.EmployeeProfileMeatballRehire);
            this.notify.success('employees.rehire.rehireWasSuccessful');
            this.router.navigate(['/', 'employees', 'directory', this.employee.id]);
        } catch (e) {
            this.notify.error(e);
            this.isLoading = false;
        }
    }
}
